<template>
	<div>
		<div class="d-flex gap-x-2">
			<h1 class="font-weight-bolder">Reporte de torneos</h1>
			<b-button-group class="mb-1">
				<b-button
					:variant="result === 'triunfo' ? 'primary' : 'outline-primary'"
					:active="result === 'triunfo'"
					@click="result = 'triunfo'"
				>
					Triunfos
				</b-button>
				<b-button
					:variant="result === 'derrota' ? 'primary' : 'outline-primary'"
					:active="result === 'derrota'"
					@click="result = 'derrota'"
				>
					Derrotas
				</b-button>
			</b-button-group>
		</div>
		<div :key="result">
			<b-row class="mb-2">
				<b-col cols="6">
					<div class="p-1 bg-white card m-0 h-100">
						<TopSonResultsChart :category_id="1" :result="result" />
					</div>
				</b-col>

				<b-col cols="6">
					<div class="p-1 bg-white card m-0 h-100">
						<TopSonResultsTableDetail :category_id="1" :result="result" />
					</div>
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6">
					<div class="p-1 bg-white card m-0 h-100">
						<TopSonResultsChart :category_id="2" :result="result" />
					</div>
				</b-col>

				<b-col cols="6">
					<div class="p-1 bg-white card m-0 h-100">
						<TopSonResultsTableDetail :category_id="2" :result="result" />
					</div>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import TopSonResultsChart from "@/views/amg/specimens/components/mainDashboard/top-son-results/components/TopSonResultsChart.vue"
import TopSonResultsTableDetail from "@/views/amg/specimens/components/mainDashboard/top-son-results/components/TopSonResultsTableDetail.vue"
export default {
	components: {
		TopSonResultsChart,
		TopSonResultsTableDetail,
	},
	data() {
		return {
			result: "triunfo",
		}
	},
}
</script>
